import { render, staticRenderFns } from "./EditScopeOfPracticeModal.vue?vue&type=template&id=5c791f54&scoped=true&"
import script from "./EditScopeOfPracticeModal.vue?vue&type=script&lang=js&"
export * from "./EditScopeOfPracticeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c791f54",
  null
  
)

export default component.exports